import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getStudentById } from "../../services/StudentService";
import {
  changeUserPassword,
  getUserByUsername,
} from "../../services/AuthService";
import { ToastContainer } from "react-toastify";
import { HSTSToast } from "../../utils/hstsToast";

export const ChangeStdPassword = () => {
  const { id: studentId } = useParams();
  const [studentEmail, setStudentEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [inputType, setInputType] = useState({
    new: "password",
    confirm: "password",
  });

  const [errors, setErrors] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [valid, setValid] = useState({
    newPassword: false,
    confirmPassword: false,
  });

  const validateField = (fieldName, value) => {
    const updatedErrors = { ...errors };
    const updatedValid = { ...valid };

    if (fieldName === "newPassword") {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

      if (!value.trim()) {
        updatedErrors.newPassword = "New password is required.";
        updatedValid.newPassword = false;
      } else if (!passwordRegex.test(value)) {
        updatedErrors.newPassword =
          "Password must be at least 8 characters long, include uppercase, lowercase, number, and special character.";
        updatedValid.newPassword = false;
      } else {
        updatedErrors.newPassword = "";
        updatedValid.newPassword = true;
      }
    }

    if (fieldName === "confirmPassword") {
      if (!value.trim()) {
        updatedErrors.confirmPassword = "Confirm password is required.";
        updatedValid.confirmPassword = false;
      } else if (value !== newPassword) {
        updatedErrors.confirmPassword = "Confirm password does not match.";
        updatedValid.confirmPassword = false;
      } else {
        updatedErrors.confirmPassword = "";
        updatedValid.confirmPassword = true;
      }
    }

    setErrors(updatedErrors);
    setValid(updatedValid);
  };

  const formValidation = () => {
    validateField("newPassword", newPassword);
    validateField("confirmPassword", confirmPassword);

    return (
      valid.newPassword &&
      valid.confirmPassword &&
      !errors.newPassword &&
      !errors.confirmPassword
    );
  };

  const savePassword = (e) => {
    e.preventDefault();

    if (formValidation()) {
      const user = {
        currentPassword: newPassword,
        newPassword: newPassword,
      };

      changeUserPassword(userId, user)
        .then(() => {
          HSTSToast("success", "Password changed successfully");
        })
        .catch((error) => {
          HSTSToast("error", "Something went wrong, please try again");
          console.error(error);
        });
    }
  };

  useEffect(() => {
    if (studentId) {
      getStudentById(studentId)
        .then((res) => {
          const userEmail = res.data?.data?.email_address;
          setStudentEmail(userEmail);
        })
        .catch((error) =>
          console.error("Something wrong on student details ", error)
        );
    }
  }, [studentId]);

  useEffect(() => {
    if (studentEmail) {
      getUserByUsername(studentEmail)
        .then((res) => {
          const userData = res.data.data.user_id;

          setUserId(userData);
        })
        .catch((er) => console.error(" Something wrong on student email ", er));
    }
  }, [studentEmail]);
  return (
    <>
      <ToastContainer />
      <div className="row">
        <div className="col-12 col-md-8  col-lg-4">
          <div className="card-body">
            <h5 className="mb-3">
              <span className="fas fa-award text-primary"></span> Change
              student`s password
            </h5>
            <form>
              <div className="form-group">
                <label className="text-black">Enter new password</label>
                <input
                  type={inputType.new}
                  className={`form-control ${
                    errors.newPassword
                      ? "is-invalid"
                      : valid.newPassword
                      ? "is-valid"
                      : ""
                  }`}
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    validateField("newPassword", e.target.value);
                  }}
                  onFocus={() =>
                    setInputType((prev) => ({ ...prev, new: "text" }))
                  }
                  onBlur={() => {
                    setInputType((prev) => ({
                      ...prev,
                      new: "password",
                    }));
                    validateField("newPassword", newPassword);
                  }}
                  placeholder="Please enter new password"
                />
                {errors.newPassword && (
                  <div className="invalid-feedback">{errors.newPassword}</div>
                )}
              </div>

              <div className="form-group">
                <label className="text-black">Enter confirm password</label>
                <input
                  type={inputType.confirm}
                  className={`form-control ${
                    errors.confirmPassword
                      ? "is-invalid"
                      : valid.confirmPassword
                      ? "is-valid"
                      : ""
                  }`}
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    validateField("confirmPassword", e.target.value);
                  }}
                  onFocus={() =>
                    setInputType((prev) => ({
                      ...prev,
                      confirm: "text",
                    }))
                  }
                  onBlur={() => {
                    setInputType((prev) => ({
                      ...prev,
                      confirm: "password",
                    }));
                    validateField("confirmPassword", confirmPassword);
                  }}
                  placeholder="Please enter confirm password"
                />
                {errors.confirmPassword && (
                  <div className="invalid-feedback">
                    {errors.confirmPassword}
                  </div>
                )}
              </div>

              <div className="form-group mb-3">
                <button
                  className="btn btn-black w-100 rounded-3"
                  onClick={savePassword}
                >
                  Change password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
